var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isApp)?_c('app-header'):_vm._e(),_c('router-view',{class:{'is-app': _vm.isApp}}),(!_vm.isLocationChange && !_vm.isCalendarChange && !_vm.isApp && !_vm.car)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }